<template>
    <div class="instead-auth">
        <div
            v-if="showAuthSuccess"
            class="instead-auth-success"
        >
            <v-icon name="instead-success" />
            <p>{{ $t('代开发应用配置完成，已授权通讯录') }}<br>{{ $t('请继续') }}</p>
            <steps-bottom
                :btn-disabled="false"
                :is-last-step="isLastStep"
                @btnClick="onCompleteBtnClick"
            />
        </div>
        <div
            v-else-if="showAuthCode"
            class="instead-auth-config"
        >
            <div class="instead-auth-module">
                <div
                    class="instead-auth-module-img longImg"
                />
                <div class="instead-auth-module-right">
                    <div
                        class="instead-auth-module-tit"
                    >
                        {{ $t('请在联系到企点专员后，扫描下方二维码，授权企点专员协助您代开发应用配置') }}
                    </div>
                    <div class="instead-auth-module-desc">
                        {{ $t('如果您已扫码并联系到企点专员，请耐心等待应用代开发配置完成（约需15分钟）') }}
                    </div>
                    <div class="instead-auth-module-authImg">
                        <img :src="authCode">
                    </div>

                    <div
                        v-show="UnboundInit"
                        class="instead-auth-module-init"
                    >
                        <div class="instead-auth-module-tit">
                            {{ $t('您未绑定企业，请填写并提交企业ID') }}
                        </div>
                        <div
                            class="instead-auth-module-desc"
                            style="margin-bottom: 12px;"
                        >
                            {{ $t('可在「企业微信管理后台」-「我的企业」中获取') }}
                            <span
                                v-tip:sessionPreview.hover.delay
                                class="instead-auth-module-graphic"
                            >{{ $t('查看图示') }}</span>
                            <a
                                @click="externalJump('https://work.weixin.qq.com/wework_admin/frame#profile')"
                                style="cursor: pointer;"
                            >{{ $t('前往获取') }}</a>
                        </div>
                        <v-tip
                            ref="sessionPreview"
                            kind="large"
                            placement="bottom-start"
                        >
                            <div class="instead-auth-module-preview">
                                <div class="instead-auth-module-session" />
                            </div>
                        </v-tip>
                        <div class="clearfix">
                            <v-form
                                ref="EnterpriseForm"
                                class="instead-auth-module-form"
                            >
                                <v-form-item
                                    v-model="EnterpriseError"
                                    name="enterprise"
                                    error-placement="bottom"
                                >
                                    <v-input
                                        v-model="EnterpriseId"
                                        :clearable="true"
                                        :width="300"
                                        class="demo-default-input"
                                        :placeholder="$t('企业ID')"
                                        autofocus
                                    />
                                </v-form-item>
                            </v-form>
                            <v-button
                                :disabled="EnterpriseId == ''"
                                @click="EnterpriseIdBtn"
                                kind="primary"
                                class="instead-auth-module-btn"
                            >
                                {{ $t('提交') }}
                            </v-button>
                        </div>
                    </div>
                    <div
                        v-show="bindInit"
                        class="instead-auth-module-init"
                    >
                        <div class="instead-auth-module-tit">
                            {{ $t('您已绑定企业"{name}"', { name: authCorpName }) }}
                        </div>
                        <div class="instead-auth-module-desc">
                            {{ $t('企业ID为') }} {{ authCorpId }}
                        </div>
                    </div>
                    <div v-show="insteadBoxShow">
                        <div class="instead-auth-module-box">
                            <p
                                v-show="scanShow"
                                class="instead-auth-module-box-icon clearfix"
                            >
                                <span
                                    :class="{
                                        'icon-wait': scanInit === 0,
                                        'icon-loading': scanInit == 1,
                                        'icon-complete': scanInit == 2,
                                    }"
                                    class="icon-left"
                                />
                                <span
                                    :class="{
                                        'set-wait': scanInit === 0,
                                        'set-loading': scanInit == 1,
                                        'set-complete': scanInit == 2,
                                    }"
                                >
                                    {{ $t('使用你的企业微信扫描二维码，授权企点专员协助您代开发应用配置') }}
                                </span>
                            </p>
                            <p
                                v-show="scopeShow"
                                class="instead-auth-module-box-icon clearfix"
                            >
                                <span
                                    :class="{
                                        'icon-wait': scopeInit === 0,
                                        'icon-loading': scopeInit == 1,
                                        'icon-complete': scopeInit == 2,
                                    }"
                                    class="icon-left"
                                />
                                <span
                                    :class="{
                                        'set-wait': scopeInit === 0,
                                        'set-loading': scopeInit == 1,
                                        'set-complete': scopeInit == 2,
                                    }"
                                >
                                    <i18n-t path="到「企业微信后台」-{appMng}，设置该应用的可见范围为全员可见" tag="span">
                                        <a
                                            slot="appMng"
                                            @click="externalJump('https://work.weixin.qq.com/wework_admin/frame#apps')"
                                            style="cursor: pointer;"
                                        >{{ $t('「应用管理」') }}</a>
                                    </i18n-t></span>
                            </p>
                            <p
                                v-show="authShow"
                                class="instead-auth-module-box-icon clearfix"
                            >
                                <span
                                    :class="{
                                        'icon-wait': authInit === 0,
                                        'icon-loading': authInit == 1,
                                        'icon-complete': authInit == 2,
                                    }"
                                    class="icon-left"
                                />
                                <span
                                    :class="{
                                        'set-wait': authInit === 0,
                                        'set-loading': authInit == 1,
                                        'set-complete': authInit == 2,
                                    }"
                                >{{ $t('在企业微信授权员工基本信息') }}</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="instead-auth-img">
                <img :src="authCode">
            </div> -->
            <!-- <div class="instead-auth-tit">
                请在联系到企点专员后，扫描下方二维码，授权企点专员协助您代开发应用配置
            </div>
            <div class="instead-auth-desc">
                如果您已扫码并联系到企点专员，请耐心等待应用代开发配置完成（约需15分钟）
            </div> -->
            <steps-bottom
                :btn-disabled="btnDisabled"
                :is-last-step="isLastStep"
                @cancelBtnClick="onCancelBtnClick"
                @btnClick="onBtnClick"
                :cancel-btn-txt="$t('未联系到企点专员')"
            />
        </div>
        <div
            v-else
            class="instead-auth-friend"
        >
            <!-- <div class="instead-auth-img instead-auth-img-friend" /> -->
            <div
                :class="InsteadAuthImg"
                class="instead-auth-img"
            />
            <div class="instead-auth-tit">
                {{ $t('扫描上方二维码，联系企点专员帮助您配置通讯录') }}
            </div>
            <steps-bottom
                :btn-disabled="false"
                @btnClick="onContactBtnClick"
                :confirm-btn-txt="$t('我已联系到企点专员')"
                :desc-txt="$t('请企点专员回复后，点击此按钮')"
            />
        </div>
    </div>
</template>

<script>
import { Icon } from 'vhtml-ui';
import Gateway from '@/utils/Gateway';
// import getAuthorizeAppResult from '@/pages/mng/weworkCombine/api/getAuthorizeAppResult';
import StepsBottom from '../../steps-bottom';
// import getQrcodeUrl from '@/pages/mng/weworkCombine/api/getQrcodeUrl';
import { hasPackages } from '@/utils/package';

const sprites = require.context('./assets/icons', true, /[^.]+\.svg$/);
Icon.addSprites(sprites);

export default {
    components: {
        StepsBottom,
    },

    props: {
        isLastStep: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            showAuthCode: false,
            showAuthSuccess: false,
            authCode: '',
            resultTimer: null,
            EnterpriseId: '',
            UnboundInit: false,
            bindInit: false,
            ModuleImg: true,
            scanInit: 0,
            scopeInit: 0,
            authInit: 0,
            authCorpId: '',
            scanShow: false,
            scopeShow: false,
            authShow: false,
            EnterpriseError: '',
            authCorpName: '',
            hasInstall: false,
            btnDisabled: true,
            insteadBoxShow: false,
            QrCodeTimer: null,
        };
    },
    computed: {
        InsteadAuthImg() {
            if (hasPackages([10019, 10028, 10035, 10063, 10064, 10065, 10138])) {
                return 'instead-auth-img-friend';
            }
            return 'instead-auth-img-code';
        },
    },

    created() {
        // getQrcodeUrl()
        //     .then((data) => {
        //         this.authCode = data.QrcodeUrl;
        //         this.authCorpId = data.QrCorpId;
        //         this.getAuthorize();
        //     });
        this.getQrcodeUrl();
    },
    methods: {
        onContactBtnClick() {
            this.showAuthCode = true;
            if (!this.authCorpId) {
                this.UnboundInit = true;
                this.bindInit = false;
                this.insteadBoxShow = false;
            } else {
                this.bindInit = true;
                this.insteadBoxShow = true;
                this.setResultTimer();
            }
            // this.setResultTimer(); // 轮询走下一步
        },

        onCancelBtnClick() {
            this.showAuthCode = false;
            this.clearResultTimer();
        },

        onCompleteBtnClick() {
            this.$emit('success');
        },

        // getQrcodeUrl() {
        //     Gateway.get('/v1/corp/wework/InsteadAppQrCode', { template: 'address_book' })
        //         .then(data => {
        //             const { url } = data || {};
        //             this.authCode = url;
        //         })
        //         .catch(msg => {
        //             this.$message.error(msg || '获取二维码信息失败');
        //         });
        // },
        // 轮询逻辑
        setResultTimer() {
            this.clearResultTimer();
            this.resultTimer = setTimeout(() => {
                let QrcodeParams = '';
                let suiteId = '';
                suiteId = this.$route.query.suiteId;
                if (!suiteId) {
                    QrcodeParams = 'address_book';
                } else {
                    QrcodeParams = suiteId;
                }
                Gateway.get('/v1/basic/corp/wework/authorizeAppResult', { template: QrcodeParams }).then((data) => {
                    const { status, step } = data || {};
                    const hasInstall = (status == step.length);
                    if (step.length == 3) {
                        switch (status) {
                        case 0:
                            this.scanInit = 1;
                            break;
                        case 1:
                            this.scanInit = 2;
                            this.scopeInit = 1;
                            break;
                        case 2:
                            this.scanInit = 2;
                            this.scopeInit = 2;
                            this.authInit = 1;
                            break;
                        case 3:
                            this.scanInit = 2;
                            this.scopeInit = 2;
                            this.authInit = 2;
                            break;
                        }
                    } else if (step.length == 2) {
                        if (step[0] == 'scan' && step[1] == 'scope') {
                            switch (status) {
                            case 0:
                                this.scanInit = 1;
                                break;
                            case 1:
                                this.scanInit = 2;
                                this.scopeInit = 1;
                                break;
                            case 2:
                                this.scanInit = 2;
                                this.scopeInit = 2;
                                break;
                            }
                        } else if (step[0] == 'scan' && step[1] == 'authorize') {
                            switch (status) {
                            case 0:
                                this.scanInit = 1;
                                break;
                            case 1:
                                this.scanInit = 2;
                                this.authInit = 1;
                                break;
                            case 2:
                                this.scanInit = 2;
                                this.authInit = 2;
                                break;
                            }
                        }
                    }
                    this.hasInstall = hasInstall;
                    this.btnDisabled = !hasInstall;
                    if (!hasInstall) {
                        this.setResultTimer();
                    }
                });
            }, 3000);
        },

        clearResultTimer() {
            if (this.resultTimer) {
                clearTimeout(this.resultTimer);
            }
        },
        externalJump(path) {
            window.open(path, '_blank');
        },
        // 为了展示初始化轮询文案
        getAuthorize() {
            let QrcodeParams = '';
            let suiteId = '';
            suiteId = this.$route.query.suiteId;
            if (!suiteId) {
                QrcodeParams = 'address_book';
            } else {
                QrcodeParams = suiteId;
            }
            Gateway.get('/v1/basic/corp/wework/authorizeAppResult', { template: QrcodeParams }).then((data) => {
                const { step } = data || {};
                if (step.length == 3) {
                    this.scanShow = true,
                    this.scopeShow = true,
                    this.authShow = true;
                } else if (step.length == 2) {
                    if (step[0] == 'scan' && step[1] == 'scope') {
                        this.scanShow = true,
                        this.scopeShow = true;
                    } else if (step[0] == 'scan' && step[1] == 'authorize') {
                        this.scanShow = true,
                        this.authShow = true;
                    } else {
                        this.scopeShow = true,
                        this.authShow = true;
                    }
                }
            });
        },
        // 提交企业ID
        EnterpriseIdBtn() {
            const corpId = this.EnterpriseId;
            Gateway.post(
                '/v1/basic/corp/wework/SetCorpId',
                {
                    corp_id: corpId,
                },
                {
                    originRes: true,
                }
            )
                .then((res) => {
                    const { code } = res || {};
                    if (code != 0) {
                        this.showError();
                    } else {
                        this.UnboundInit = false;
                        this.QrCodeTimer = setTimeout(() => {
                            const that = this;
                            that.getQrcodeUrl();
                        }, 500);
                    }
                })
                .catch((message) => {
                    this.$message.error(message || this.$t('获取二维码信息失败'));
                });
        },
        showError() {
            this.EnterpriseError = this.$t('与企业不匹配，请输入正确的企业ID');
            this.EnterpriseId = '';
        },
        // 提交企业ID之后再调取一次这个文案，做绑定逻辑展示
        getQrcodeUrl() {
            let QrcodeParams = '';
            let suiteId = '';
            suiteId = this.$route.query.suiteId;
            if (!suiteId) {
                if (hasPackages([10019, 10028, 10035, 10063, 10064, 10065, 10138])) {
                    QrcodeParams = 'private_domain';
                } else {
                    QrcodeParams = 'address_book';
                }
            } else {
                QrcodeParams = suiteId;
            }
            Gateway.get('/v1/corp/wework/InsteadAppQrCode', { template: QrcodeParams })
                .then((data) => {
                    const { url, corpid } = data || {};
                    this.authCode = url;
                    this.authCorpId = corpid;
                    this.authCorpName = data.corp_name;
                    if (!this.authCorpId) {
                        this.UnboundInit = true;
                        this.insteadBoxShow = false;
                    } else {
                        this.bindInit = true;
                        this.insteadBoxShow = true;
                        this.clearQrCodeTimer();
                        this.getAuthorize();
                        this.setResultTimer();
                    }
                })
                .catch((msg) => {
                    this.$message.error(msg || this.$t('获取二维码信息失败'));
                });
        },
        onBtnClick() {
            let suiteId = '';
            suiteId = this.$route.query.suiteId;
            if (!suiteId) {
                this.showAuthSuccess = this.hasInstall;
                this.showAuthCode = false;
            } else {
                window.location.href = '/mng/weworkAccount/index/app';
            }
        },
        clearQrCodeTimer() {
            if (this.QrCodeTimer) {
                clearTimeout(this.QrCodeTimer);
            }
        },
    },
};
</script>
<style scoped lang="less">
@import './instead-auth.less';
</style>
